/**
 * Ho-SYS Service Worker Registration
 * Registra el SW i gestiona actualitzacions
 */

let waitingWorker = null;

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          console.log('[SW] Registrat correctament:', registration.scope);

          // Check for updates periodically (every 30 min)
          setInterval(() => {
            registration.update();
          }, 30 * 60 * 1000);

          // If there is already a waiting worker, notify immediately
          if (registration.waiting && navigator.serviceWorker.controller) {
            waitingWorker = registration.waiting;
            window.dispatchEvent(new CustomEvent('hosys:sw-update-available'));
          }

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (!installingWorker) return;
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // New version available
                  console.log('[SW] Nova versió disponible');
                  waitingWorker = installingWorker;
                  window.dispatchEvent(new CustomEvent('hosys:sw-update-available'));
                } else {
                  // First install
                  console.log('[SW] Contingut cachejat per offline');
                }
              }
            };
          };
        })
        .catch((error) => {
          console.error('[SW] Error de registre:', error);
        });

      // When the new SW takes control, reload to pick up fresh assets
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });
    });
  }
}

/**
 * Activate the waiting SW (called when user clicks "Recarregar" on banner)
 */
export function activateWaitingWorker() {
  if (waitingWorker) {
    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  } else if (navigator.serviceWorker && navigator.serviceWorker.controller) {
    // Fallback: try to trigger update manually
    window.location.reload();
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}

/**
 * Trigger manual sync of offline queue
 */
export function triggerSync() {
  if (navigator.serviceWorker && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({ type: 'SYNC_OFFLINE_QUEUE' });
  }
}
